import { Component, Input, OnInit } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoDirective } from '@ngneat/transloco';
import { inlineLoaderFactory } from '@rx-applications/shared/utils';

import { reviewPaths } from './hotel-reviews';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'rx-review-score',
  templateUrl: './review-score.component.html',
  styleUrls: ['./review-score.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: {
        scope: 'reviewScore',
        loader: inlineLoaderFactory((lang: string) => import(`./assets/i18n/${lang}.json`)),
      },
    },
  ],
  imports: [TranslocoDirective, DecimalPipe],
})
export class ReviewScoreComponent implements OnInit {
  /**
   * Review score.
   */
  @Input() score: number;
  /**
   * Number of reviewers.
   */
  @Input() count: number;
  /**
   * Review score keyword.
   */
  keyword: string;

  ngOnInit() {
    const rating = reviewPaths[Math.floor(this.score).toString()] || reviewPaths['other'];
    this.keyword = `keywords.${rating}`;
  }
}
